export const formatCardExpirationDate = (
  expirationMonth: number,
  expirationYear: number,
): string => {
  const month = expirationMonth.toString().padStart(2, '0');
  const year = expirationYear.toString().slice(-2);

  return `${month}/${year}`;
};
